<template>
  <Row>
    <Col span="6">
      <template v-if="pattern=='model'">
        必填
        <Checkbox label="必填" v-model="content.must"></Checkbox>
        <Input style="width:100px" v-model="content.title" :disabled="$route.name!='approvalCreate'" placeholder="请输入标题"></Input>
      </template>
      <div style="display: inline-block;width:100px;text-align: right;vertical-align:middle;" v-else>{{content.title}}<span style="color: red" v-if="content.must">*</span></div>
      ：
    </Col>
    <Col span="18">
      <Upload
          ref="uploadFiles"
          multiple
          v-if="pattern=='submission'"
          :on-success="syncFiles"
          :on-remove="syncFiles"
          :disabled="pattern=='model'"
          style="display: inline-block;vertical-align:middle"
          :headers="{GroupId:groupId,Con:'R',Fun:'upload_file',UserLogin:phoneNumber,UserToken:userToken,Ver:'v1'}"
          :data="{MenuId:menuId,UserId:userId}"
          :action="getServerURL('default',true)">
        <Button
            icon="ios-cloud-upload-outline"
            type="success"
        >
          请选择文件
        </Button>
      </Upload>
      <template v-else>
        <template v-if="content.files.length>0">
          <a v-for="(item,index) in content.files" :href="getServerURL('default',false)+'/'+item.src" v-if="item.src!=null" target="_blank">
            <div style="margin-left: 10px;">{{item.name}}</div>
          </a>
        </template>
        <template v-else>暂未上传文件</template>
      </template>
      <template v-if="pattern=='model' && companyName=='云联'">
        <i-switch size="large" style="margin-left:10px" true-value="1" false-value="0" v-model="content.seal">
          <span slot="open">盖章</span>
          <span slot="close">盖章</span>
        </i-switch>
        <!--<DatePicker type="date" :disabled="disabled" placeholder="文件" @on-change="content.selected = $event" style="width: 200px"></DatePicker>-->
        <Icon class="close-icon" type="md-close-circle" @click="$emit('del',index)"></Icon>
      </template>
    </Col>
  </Row>
</template>

<script>
  export default {
    name: "approvalFiles",
    props:{
      index:Number,
      pattern:String,
      contentIn:Object,
    },
    data:function () {
      return{
        content:{
          title:'',
          files:[],
					seal:"0",
          must:false,
          allowSubmission:false,
        },
      }
    },
    methods:{
      syncFiles:function (response,file,fileList) {
        var fileList = fileList||file
        this.content.files = []
        for(var i=0;i<fileList.length;i++){
          try{
            this.content.files[i] = {name:fileList[i].response.Data.name,src:fileList[i].response.Data.path}
          }catch(e){
            console.log("error")
          }
        }
        console.log(this.content.files)
      }
    },
    watch:{
      content:{
        handler(){
          if(this.content.must!=true||this.content.files.length>0){
            this.content.allowSubmission = true
          }else{
            this.content.allowSubmission = false
          }
          this.$emit('change',this.content)
        },
        deep:true,
        immediate:true,
      }
    },
    mounted:function () {
      if(this.contentIn.title!=undefined){
        this.content = this.contentIn
      }
    },
    computed:{
			companyName:function(){
				return companyName
			},
      phoneNumber:function () {
        return window.sessionStorage.phoneNumber
      },
      userToken:function () {
        return window.sessionStorage.userToken
      },
      groupId:function () {
        return window.sessionStorage.groupId
      },
      menuId:function () {
        return window.sessionStorage.menuId
      },
      userId:function () {
        return window.sessionStorage.userId
      },
    },
  }
</script>

<style scoped>

</style>